import { useState } from "react";
import { useHistory } from "react-router-dom";
// react-bootstrap components
import { Collapse, Nav } from "react-bootstrap";

// verifies if routeName is the one active (in browser input)
export const activeRoute = (prop, location) => {
  let routeName = "",
    to = prop.to;

  if (prop.path) {
    to = prop.path;
  }
  routeName = prop.layout + to;

  let subPages = prop.subPages || [];
  return location.pathname === routeName || subPages.includes(location.pathname)
    ? "active"
    : "";
};
export const expanded = (prop, location) => {
  return prop.views.find((r) => r.to === location.pathname) ? true : false;
};
export const expandedCheckSubTab = (prop, location) => {
  return prop?.views?.find((r) =>
    r?.subPages?.find((x) => x === location.pathname)
  )
    ? true
    : false;
};
function NavList({
  collapsible = true,
  routes = [],
  location = { pathname: "" },
  orgId,
  menuType,
}) {
  const history = useHistory();
  let reportOrgId = localStorage.getItem("reportOrgId");

  // Handle navigation with deferred execution to prevent DOM race conditions
  const handleNavigation = (e, targetPath) => {
    e.preventDefault();
    // Use requestAnimationFrame to defer navigation until after current DOM operations complete
    requestAnimationFrame(() => {
      history.push(targetPath);
    });
  };

  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.jsx - route /regular-forms
  const getCollapseInitialState = (routes) => {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (location.pathname === routes[i].layout + routes[i].to) {
        return true;
      } else if (
        routes[i].path &&
        location.pathname === routes[i].layout + routes[i].path
      ) {
        return true;
      }
    }
    return false;
  };

  // this creates the intial state of this component based on the collapse routes
  // that it gets through routes prop

  const getCollapseStates = (routes) => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: getCollapseInitialState(prop.views),
          ...getCollapseStates(prop.views),
          ...initialState,
        };
      }
      return null;
    });
    return initialState;
  };

  // this is for the rest of the collapses
  const [state, setState] = useState(getCollapseStates(routes));

  // this function creates the links and collapses that appear in the sidebar (left menu)
  const createLinksDashboard = (routes) => {
    let organisationDashboards = [];
    let workspaceDashboards = [];
    let normalDashboards = [];
    let otherDashboards = [];
    let topMenu = [];
    for (let index = 0; index < routes.length; index++) {
      const element = routes[index];
      if (element.reportType === "ORGANIZATION") {
        organisationDashboards.push(element);
      } else if (element.reportType === "WORKSPACE") {
        workspaceDashboards.push(element);
      } else if (element.reportType === "NORMAL") {
        normalDashboards.push(element);
      } else if (element.type === "bi") {
        otherDashboards.push(element);
      } else if (element.view) {
        topMenu.push(element);
      }
    }
    return (
      <>
        {createLinks(topMenu)}
        {topMenu.length > 0 &&
          (organisationDashboards.length > 0 ||
            normalDashboards.length > 0 ||
            workspaceDashboards.length > 0 ||
            otherDashboards.length > 0) && (
            <hr
              style={{
                color: "lime",
                height: "1px",
                margin: "10px 10px 10px 40px",
              }}
            />
          )}
        {createLinks(organisationDashboards)}
        {organisationDashboards.length > 0 &&
          (normalDashboards.length > 0 ||
            workspaceDashboards.length > 0 ||
            otherDashboards.length > 0) && (
            <hr
              style={{
                color: "lime",
                height: "1px",
                margin: "10px 10px 10px 40px",
              }}
            />
          )}
        {createLinks(normalDashboards)}
        {normalDashboards.length > 0 &&
          (workspaceDashboards.length > 0 || otherDashboards.length > 0) && (
            <hr
              style={{
                color: "lime",
                height: "1px",
                margin: "10px 10px 10px 40px",
              }}
            />
          )}
        {createLinks(workspaceDashboards)}
        {workspaceDashboards.length > 0 && otherDashboards.length > 0 && (
          <hr
            style={{
              color: "lime",
              height: "1px",
              margin: "10px 10px 10px 40px",
            }}
          />
        )}
        {createLinks(otherDashboards)}
      </>
    );
  };
  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }
      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !state[prop.state];
        return (
          (prop.view === undefined || prop.view === null || prop.view === true
            ? prop.views && prop.views.length > 0
              ? prop.views.find((item) => item.view)
              : true
            : false) && ( // If a value for view is false, it overrides the check for at least one visible view in the views property
            <Nav.Item
              className={getCollapseInitialState(prop.views) ? "active" : ""}
              as="li"
              key={key}
              style={{ background: prop.background && prop.background }}
            >
              <Nav.Link
                className={
                  state[prop.state] ||
                  !collapsible ||
                  expanded(prop, location) ||
                  expandedCheckSubTab(prop, location)
                    ? "collapsed nav-category"
                    : "nav-category"
                }
                data-toggle="collapse"
                onClick={(e) => {
                  e.preventDefault();
                  setState({ ...state, ...st });
                }}
                aria-expanded={
                  state[prop.state] ||
                  expanded(prop, location) ||
                  expandedCheckSubTab(prop, location)
                }
                style={{ cursor: "default" }}
              >
                {prop.icon}

                <p
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  title={prop.title || prop.name}
                >
                  {prop.name} {collapsible && <b className="caret"></b>}
                </p>
              </Nav.Link>
              <Collapse
                in={
                  state[prop.state] ||
                  !collapsible ||
                  expanded(prop, location) ||
                  expandedCheckSubTab(prop, location)
                }
              >
                <div>
                  <Nav as="ul">
                    {prop.name === "Dashboards"
                      ? createLinksDashboard(prop.views)
                      : createLinks(prop.views)}
                  </Nav>
                </div>
              </Collapse>
            </Nav.Item>
          )
        );
      }
      return (
        prop.view && (
          <Nav.Item className={activeRoute(prop, location)} key={key} as="li">
            <Nav.Link
              href={
                prop.layout +
                `${
                  orgId && menuType !== "MAIN"
                    ? `${prop.to}?org=${orgId}${
                        prop.param ? `&` + prop.param : ""
                      }`
                    : `${
                        prop.category === "dashboard" && reportOrgId
                          ? prop.to + "?org=" + reportOrgId
                          : prop.to
                      }`
                }`
              }
              onClick={(e) =>
                handleNavigation(
                  e,
                  prop.layout +
                    `${
                      orgId && menuType !== "MAIN"
                        ? `${prop.to}?org=${orgId}${
                            prop.param ? `&` + prop.param : ""
                          }`
                        : `${
                            prop.category === "dashboard" && reportOrgId
                              ? prop.to + "?org=" + reportOrgId
                              : prop.to
                          }`
                    }`
                )
              }
              style={{
                cursor: "pointer",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              title={prop.title || prop.name}
            >
              {prop.name && (
                <>
                  <span className="sidebar-normal">{prop.name}</span>
                </>
              )}
            </Nav.Link>
          </Nav.Item>
        )
      );
    });
  };

  return <Nav as="ul">{createLinks(routes)}</Nav>;
}

export default NavList;
